/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/plugins/jquery/aaToggle.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/plugins/jquery.aaToggle.js
**/

/*------------------------------------*\
$ aaToggle
\*------------------------------------*/
(function($) {
	$.fn.aaToggle = function () {
		var onClick = function(ev) {
			var trigger = $(this);
			var defaults = {
				expandText: "Expand",
				collapseText: "Collapse",
				animation: true
			};
			var settings = $.extend({}, defaults, trigger.data());
			var href = trigger.attr('href');
			var triggerHref = (href !== undefined && href !== "#") ? href : trigger.attr('data-toggle-href');
			var target = $(triggerHref);
			if (target.length > 0) {
				trigger.find('[data-toggle]').toggleClass('icon-expand').toggleClass('icon-collapse');
				trigger.find('.hidden-accessible').text(trigger.find('.hidden-accessible').text() == settings.expandText ? settings.collapseText : settings.expandText);
				target.each( function( index, element ){
					if (settings.animation) {
						$(element).stop().animate({height:'toggle'}, 500);
					} else {
						$(element).toggle();
					}
				});
			}
			ev.preventDefault();
			return true;
		};
		$(document).on('click',this.selector,onClick);

	};
})(jQuery);
